import { Component, DestroyRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { API, CompanyFullDTO } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sb-page-company-details-attributes',
  templateUrl: './company-details-attributes.component.html',
  styleUrls: ['./company-details-attributes.component.scss'],
  standalone: false,
})
export class CompanyDetailsAttributesComponent implements OnInit {
  companyId: number;
  company: CompanyFullDTO;
  loading: boolean;

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public errorHandler: ErrorService,
    private destroyRef: DestroyRef
  ) {
    this.company = undefined;
    this.companyId = undefined;
    this.loading = true;
  }

  ngOnInit() {
    this.activatedRoute.parent.params.subscribe(params => {
      this.companyId = +params.companyID;
      this.refresh();
    });
  }

  refresh() {
    this.loading = true;
    this.api
      .shared_Company_retrieveCompanyById(this.companyId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (e: CompanyFullDTO) => {
          this.company = e;
        },
        error: error => {
          if (!error.status || !(+error.status === 403 || +error.status === 404)) {
            this.errorHandler.errorHandler(error);
          }
        },
      });
  }
}
